import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { PRICE_LABEL, startCheckout } from "@/lib/checkout";
import { T } from "@/constants/testIds";
import { ShoppingBag } from "lucide-react";

export default function FloatingBuy() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const h = () => setShow(window.scrollY > 500);
    window.addEventListener("scroll", h, { passive: true });
    return () => window.removeEventListener("scroll", h);
  }, []);
  return (
    <AnimatePresence>
      {show && (
        <motion.button
          data-testid={T.floatBuy}
          onClick={startCheckout}
          initial={{ opacity: 0, y: 30, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 30, scale: 0.9 }}
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
          className="btn-pulse fixed z-50 bottom-5 right-5 md:bottom-8 md:right-8 bg-red-600 hover:bg-red-700 text-white rounded-full pl-5 pr-6 h-14 inline-flex items-center gap-3 shadow-[0_15px_40px_-10px_rgba(220,38,38,0.6)]"
        >
          <ShoppingBag className="h-5 w-5" />
          <span className="font-mono tracking-[0.2em] text-[11px] uppercase">
            Comprar ebook — {PRICE_LABEL}
          </span>
        </motion.button>
      )}
    </AnimatePresence>
  );
}
